export var isMetamaskInstalled = function () { return typeof window.ethereum !== 'undefined'; };
export var isUserDeniedError = function (error) {
    return error.message.includes('User denied transaction signature');
};
export var MetamaskErrors = {
    TRANSACTION_REJECTED: 4001,
};
//# sourceMappingURL=metamask.js.map